<!-- 选人-->
<template>
  <!-- 1.0选人组件 -->
  <yxt-drawer
    :destroy-on-close="true"
    size='1060px'
    :visible.sync="dialogVisible"
    :title="tabs.length > 1 ? '' : title"
  >
    <slot
      slot="title"
      name="title"
    />
    <!-- 2.0选人组件 -->
    <yxtbiz-range-selector
      ref="selector"
      :limit="limit"
      v-model="bindData"
      :tabs="tabsV2"
      :function-code="functionCode"
      :data-permission-code="dataPermissionCode"
      :class="['gwnl-personality-select', hideV2BizTitle ? 'gwnl-personality-select--no-header' : '']"
      @change="changeUsers"
    />
    <slot name="content" />
    <div slot="footer">
      <yxt-button
        plain
        @click="cancel"
      >
        {{ $t('pc_gwnl_global_btn_cancel') }}
      </yxt-button>
      <yxt-button
        type="primary"
        @click="getUsers"
      >
        {{ $t('pc_gwnl_global_btn_confirm') }}
      </yxt-button>
    </div>
  </yxt-drawer>
</template>
<script>
// import { RangeSelector } from 'yxt-biz-pc';
import drawerBeforeClose from './drawerBeforeClose';
export default {
  name: 'YxtbizEvalSelectUser',
  mixins: [drawerBeforeClose],
  components: {
    // [RangeSelector.name]: RangeSelector
  },
  props: {
    visible: {
      type: Boolean
    },
    tabs: {
      type: Array,
      default: () => {
        return ['persons'];
      }
    },
    community: {
      type: Object,
      default: null
    },
    groupOrg: {
      type: Boolean,
      default: false
    },
    functionCode: {
      type: String,
      default: ''
    },
    limit: {
      type: Number
    },
    min: {
      type: Number,
      default: -Infinity
    },
    data: {
      type: Array,
      default: () => {
        return [];
      }
    },
    dataPermissionCode: {
      type: String,
      default: 'eval_tools_addassessor_extent'
    },
    title: {
      type: String
    }
  },
  data() {
    return {
      dialogVisible: false,
      selectedObjs: [{ type: '', name: '', id: '' }],
      options: {
        errorCallback: function() { },
        updateCallback: function() { },
        headers: {
          token: localStorage.getItem('token'),
          Source: 501
        },
        data: {
          ouRoutingNumbers: [],
          isQueryAllDept: 1
        }
      },
      bindData: []
    };
  },
  computed: {
    // 是否隐藏2.0选人组件的tab
    hideV2BizTitle() {
      return (this.$slots && this.$slots.title) && this.tabs.length <= 1;
    },
    tabsV2() {
      return this.tabs.map(tab => {
        if (tab === 'userGroup') {
          // 如果是用户组选人，默认拆解到人
          return {
            type: tab,
            isPerson: true
          };
        }
        return tab;
      });
    }
  },
  watch: {
    data(val) {
      val.forEach(item => {
        if (this.$isV1) {
          item.type = 'person';
        } else {
          item.username = item.name;
        }
      });
    },
    visible(val) {
      this.dialogVisible = val;
      // fix 选人组件回显后 selectedObjs没有更新
      this.selectedObjs = this.data || [];
      if (val) {
        this.saveOldData(this.data.map(item => item.id));
        if (!this.$isV1) {
          this.bindData = this.data.map(user => {
            return {
              ...user,
              nodeType: 'persons'
            };
          });
        }
      }
    },
    dialogVisible(val) {
      this.$emit('update:visible', val);
    }
  },
  methods: {
    // 处理1.0的数据，和2.0字段保持统一
    updateSelected(users) {
      this.selectedObjs = users || [];
      const processedUsers = users.map((user) => {
        return {
          ...user,
          fullname: user.name
        };
      });
      this.changeUsers(processedUsers);
    },
    changeUsers(users) {
      if (!this.$refs.selector || !this.$refs.selector.getSelectDataArray) return;
      this.$refs.selector.getSelectDataArray().then((result) => {
        this.$emit('change', users);
      });
    },
    async getSelected(before = true) {
      if (this.$isV1) {
        const selectedLength = this.selectedObjs ? this.selectedObjs.length : 0;
        if (this.limit && selectedLength > this.limit) {
          this.$confirm(this.$t('pc_gwnl_udp_msg_outRange').d('已选人数超过限制，请检查'), this.$t('pc_gwnl_limitnum', [this.limit]).d(`最多可选${this.limit}条`), {
            type: 'error',
            showCancelButton: false,
            confirmButtonText: this.$t('pc_gwnl_btn_check').d('去检查')
          });
          return Promise.reject(new Error('exceed'));
        }
        return new Promise((resolve, reject) => {
          if (this.selectedObjs.length) {
            const processedSelected = this.selectedObjs.map((item) => {
              return {
                ...item,
                fullname: item.name
              };
            }).filter(item => item.id);
            resolve(processedSelected);
          } else {
            reject(new Error(this.$t('pc_gwnl_global_msg_notSelectUser').d('请选择人员')));
          }
        });
      } else {
        return new Promise((resolve, reject) => {
          if (!this.$refs.selector || !this.$refs.selector.getSelectDataArray) return reject();
          this.$refs.selector.getSelectDataArray().then((result) => {
            if (this.limit && result.length > this.limit && before) {
              this.$confirm(this.$t('pc_gwnl_udp_msg_outRange').d('已选人数超过限制，请检查'), this.$t('pc_gwnl_limitnum', [this.limit]).d(`最多可选${this.limit}条`), {
                type: 'error',
                showCancelButton: false,
                confirmButtonText: this.$t('pc_gwnl_btn_check').d('去检查')
              });
              return reject();
            }
            resolve(result);
          }).catch((error) => {
            reject(error);
          });
        });
      }
    },
    getUsers() {
      this.getSelected().then((result) => {
        if (result && result.length < this.min) {
          this.$message.warning(this.$t('pc_gwnl_global_msg_notSelectUser'));
          return;
        }
        this.$emit('getUsers', result);
      }).catch((e) => {
        if (e && e.message === '暂无选择人员') {
          this.$message.warning(this.$t('pc_gwnl_global_msg_notSelectUser'));
        }
      });
    },
    cancel() {
      this.dialogVisible = false;
    // },
    // async beforeDrawClose(done) {
    //   let newData = await this.getSelected(false).catch(() => {});
    //   done(this.isDataChanged(newData ? newData.map(item => item.id) : []));
    }
  }
};
</script>
<style lang="scss">
.gwnl-personality-select--no-header {
  .yxt-tabs__header {
    display: none;
  }
}
</style>
